import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  DialogActions,
} from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiCloseButton from "src/components/core-components/mui/buttons/ByzMuiCloseButton";
import PatientDatas from "src/modules/medcard/patient-datas";
import { Breakpoint } from '@mui/system';
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";
import ByzNurseOkeyButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseOkeyButton";

interface OpenComponentDialogProps
  extends React.PropsWithChildren<React.ComponentProps<typeof Dialog>> {
  title?: string;
  onClose: () => void;
  open: boolean;
  isMedCard?: boolean;
  isOpenMedCard?: boolean;
  maxWidth?: Breakpoint;
  showSaveButton?: boolean;
  showAddButton?: boolean;
  showOkButton?: boolean;
  onSaveClick?: () => void;
  hideHeader?: boolean;
  rowID?: any;
  showPatientData?: boolean;
}

export const OpenComponentDialog = ({
  title,
  open,
  onClose,
  children,
  isMedCard = false,
  isOpenMedCard = true,
  maxWidth = "xl",
  showSaveButton = false,
  showAddButton = false,
  showOkButton = false,
  onSaveClick,
  hideHeader = false,
  rowID,
  showPatientData = true,
  ...rest

}: OpenComponentDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      {...rest}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      maxWidth={maxWidth}
      fullWidth
      sx={{
        ".MuiPaper-root": {
          backgroundColor: "#FFF",
          // Dışarıdan gelen sx içinde .MuiPaper-root varsa onu da uygula
          ...(rest as any)?.sx?.[".MuiPaper-root"],
        },
        ...(rest as any)?.sx,
      }}
    >
      {!hideHeader && (
        <>
          <DialogTitle
            sx={{
              p: 2.5,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#F4F7FE",
              borderBottom: "1.03px solid #E0E0E0",
            }}
          >
            {showSaveButton && (//IDOGAN;453142;03042025;POPUP UST PANELE SAVE BUTTONU ISTEGE BAGLI GETIRTILEBILIR OLARAK EKLENDI.
              <ByzNurseSaveButton onClick={onSaveClick} />
            )}
            {showAddButton && (
              <ByzMuiAddButton onClick={onSaveClick} />
            )}
            {showOkButton && (
              <ByzNurseOkeyButton onClick={onSaveClick || (() => { })} />
            )}
            {title && (//IDOGAN;453142;03042025;BASLIK OLMASA BILE UST PANELIN GELMESI SAGLANDI
              <ByzMuiTypography id="dialog-title" isTitle={true}>
                {title}
              </ByzMuiTypography>
            )}
            <ByzMuiCloseButton onClick={onClose} />
          </DialogTitle>
          <Divider />
        </>
      )}
      <DialogContent sx={{ p: 2 }} id="dialog-description">
        {showPatientData && (
          <PatientDatas patientId={rowID} isOpenMedCard={true} isCreateMedCard />
        )}
        {children}
      </DialogContent>
      {/* Boş bir alan kalıyordu ileride gerekirse eklenebilir
      !hideHeader && title ? (
        <DialogActions>
        </DialogActions>
      ) : null
       */}
    </Dialog>
  );
};

export default OpenComponentDialog;